import React from "react";
import FormInput from "../../../components/common/FormInput/FormInput";
import '../auth.css';
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { useNavigate } from "react-router-dom";


const Signup = () => {
  const navigate = useNavigate();

  const SignupAuth = (e) => {
    e.preventDefault();
    navigate("/login");
  };

  return (
    <div className="login-wrapper">
      <form className="form-conatiner" onSubmit={SignupAuth}>
        <img src="/Images/magnus-logo.png" alt="logo" />
        <Row>
          <Col xs={12} >
            <label className="form-label">User name</label>
            <FormInput placeholder="Enter email" type="text" />
          </Col>
          <Col xs={12} >
            <label className="form-label">Email</label>
            <FormInput placeholder="Enter email" type="email" />
          </Col>
          <Col xs={12} >
            <label className="form-label">Password</label>
            <FormInput placeholder="Enter password" type="password" />
          </Col>
          <Col xs={12}>
            <button type="submit" className="login-btn">
              Signup
            </button>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default Signup;